import React from 'react'
import styled from 'styled-components'
import { Drawer, DrawerProps } from 'antd'

interface BaseDrawerProps {
  title: string
  open: boolean
  onClose: () => void
  children: React.ReactNode
  props?: DrawerProps
  className?: string
}

export const BaseDrawer: React.FC<BaseDrawerProps> = ({
  title,
  open,
  onClose,
  children,
  props,
  className,
}) => (
  <DrawerContainer
    title={<div className="drawer-title">{title}</div>}
    open={open}
    onClose={onClose}
    {...props}
    className={className}
    width={props?.width || 600}
  >
    {children}
  </DrawerContainer>
)

const DrawerContainer = styled(Drawer)`
  .ant-drawer-close {
    width: 36px;
    height: 36px;
    background: #d8d6f4;
    box-shadow: -1px 4px 10px 0px #c7c7c7;
    border-radius: 6px;
    border: none;
    margin-right: 0px;
    color: #4238c9;
    font-size: 16px;
    font-weight: 500;
    position: absolute;
    right: 0px;
    top: 0px;
    transition: transform 0.3s ease;

    &:hover {
      transform: translate(-10px, 8px);
      box-shadow: 0 0 0 0;
    }

    .ant-drawer-close-x {
      width: 100%;
      height: 100%;
      line-height: 36px;
      text-align: center;
    }
  }

  .ant-drawer-header {
    height: 56px;
    background: #f2f0ff;
    border-bottom: none;
    margin: 0;
  }

  .drawer-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    position: relative;
    padding-left: 12px;
    &::before {
      content: '';
      display: block;
      width: 4px;
      height: 16px;
      background: linear-gradient(180deg, #958dee 0%, #4238c9 100%);
      border-radius: 2px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .ant-drawer-close {
    width: 36px;
    height: 36px;
    background: #d8d6f4;
    box-shadow: -1px 4px 10px 0px #c7c7c7;
    border-radius: 6px;
    border: none;
    margin-right: 0px;
    color: #4238c9;
    font-size: 16px;
    font-weight: 500;
    position: absolute;
    right: 0px;
    top: 0px;
    transition: transform 0.3s ease;

    &:hover {
      transform: translate(-10px, 8px);
      box-shadow: 0 0 0 0;
    }

    .ant-drawer-close-x {
      width: 100%;
      height: 100%;
      line-height: 36px;
      text-align: center;
    }
  }
`
